"use strict";
/// <reference path="../../../../Trillium.UI/TypeScript/Models/General/UI/TriSnackBardModel.tsx"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Snackbar_1 = __importDefault(require("@material-ui/core/Snackbar"));
var Alert_1 = __importDefault(require("@material-ui/lab/Alert"));
var CircularProgress_1 = __importDefault(require("@material-ui/core/CircularProgress"));
var TriSnackBarWidget = /** @class */ (function (_super) {
    __extends(TriSnackBarWidget, _super);
    function TriSnackBarWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TriSnackBarWidget.prototype.render = function () {
        return (react_1.default.createElement(Snackbar_1.default, { anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'right'
            }, open: this.props.show && (this.props.showLoading || this.props.showMessage), autoHideDuration: this.props.time }, this.props.showLoading === true ? (react_1.default.createElement(CircularProgress_1.default, null)) : (react_1.default.createElement(Alert_1.default, { severity: this.props.success ? 'success' : 'error' }, this.props.message))));
    };
    return TriSnackBarWidget;
}(react_1.default.Component));
exports.default = TriSnackBarWidget;
